import React from 'react';

const CustomInput = ({
    label,
    name,
    type = 'text',
    placeholder,
    formik,
    options = null,
    as = 'input',
    ...props
}) => {
    const isError = formik.touched[name] && formik.errors[name];

    const inputClasses = `custom-input ${isError ? 'is-invalid' : ''}`;
    const inputId = props.id || `input-${name}`;

    return (
        <div className="custom-input-container">
            {label && <label htmlFor={inputId} className="custom-input-label">{label}</label>}
            
            {as === 'select' ? (
                <select
                    id={inputId}
                    name={name}
                    className={inputClasses}
                    {...formik.getFieldProps(name)}
                    {...props}
                >
                    <option value="">{placeholder || 'Select...'}</option>
                    {options && options.map((opt, index) => (
                        <option key={index} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
            ) : as === 'textarea' ? (
                <textarea
                    id={inputId}
                    name={name}
                    className={inputClasses}
                    placeholder={placeholder}
                    {...formik.getFieldProps(name)}
                    {...props}
                />
            ) : (
                <input
                    id={inputId}
                    type={type}
                    name={name}
                    className={inputClasses}
                    placeholder={placeholder}
                    {...formik.getFieldProps(name)}
                    {...props}
                />
            )}
            
            {isError ? (
                <div className="custom-input-error">{formik.errors[name]}</div>
            ) : (
                <div className="custom-input-error-placeholder"></div>
            )}
        </div>
    );
};

export default CustomInput;
